<template>
  <div id="app">
    <!-- 路由 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    let tempVer = window.navigator.userAgent.toLowerCase()
    if (tempVer && tempVer.match(/version\/([\d.]+).*safari/)) {
      let tempVerSon = tempVer.match(/version\/([\d.]+).*safari/)[1]
      if (tempVerSon.indexOf('.') > -1) {
        if (Number(tempVerSon.split('.')[0]) <= 12) {
          alert('请将浏览器更新为最新版本，或者使用Chrome浏览器！')
        }
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center
}
body {
  min-width: 1340px;
  margin: 0 auto;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: hidden
}
</style>



// WEBPACK FOOTER //
// src/App.vue